// AUTO-GENERATED by generate-rxdb-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { defaultHooks } from '../defaults'

const name = 'attributes'

/**
 * Attribute Model Interface (auto-generated from Drizzle schema)
 */
export interface AttributeModel {
  id: string
  orgId: string
  workspaceId?: string
  userId?: string
  createdAt: string
  updatedAt: string
  metadata?: Record<string, unknown>
  extended?: Record<string, unknown>
  name: string
  title: string
  description?: string
  color: string
  entityType: string
  type: string
  sortOrder?: number
  popularity?: number
  archived: boolean
  tenantId?: string
}

export const schema = {
  title: name,
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
      "id": {
          "type": "string",
          "maxLength": 100
      },
      "orgId": {
          "type": "string",
          "maxLength": 100
      },
      "workspaceId": {
          "type": "string",
          "maxLength": 100
      },
      "userId": {
          "type": "string",
          "maxLength": 100
      },
      "createdAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "updatedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "metadata": {
          "type": "object"
      },
      "extended": {
          "type": "object"
      },
      "name": {
          "type": "string",
          "maxLength": 500
      },
      "title": {
          "type": "string",
          "maxLength": 500
      },
      "description": {
          "type": "string",
          "maxLength": 100000
      },
      "color": {
          "type": "string",
          "maxLength": 20
      },
      "entityType": {
          "type": "string",
          "maxLength": 50
      },
      "type": {
          "type": "string",
          "maxLength": 200
      },
      "sortOrder": {
          "type": "integer",
          "minimum": 0,
          "maximum": 999999,
          "multipleOf": 1
      },
      "popularity": {
          "type": "number",
          "minimum": 0,
          "maximum": 999999,
          "multipleOf": 1
      },
      "archived": {
          "type": "boolean"
      },
      "tenantId": {
          "type": "string",
          "maxLength": 100
      }
  },
  required: [
      "id",
      "orgId",
      "createdAt",
      "updatedAt",
      "name",
      "title",
      "color",
      "entityType",
      "type",
      "archived"
  ],
  indexes: [
      [
          "orgId",
          "entityType",
          "type"
      ],
      [
          "orgId",
          "createdAt"
      ]
  ],
}

export const migrationStrategies = {}

export const Collection = {
  name,
  schema,
  hooks: {
    ...defaultHooks({ name }),
  },
  migrationStrategies,
}
